import { render } from "./LogInMenu.vue?vue&type=template&id=0fba3e46&scoped=true"
import script from "./LogInMenu.vue?vue&type=script&lang=js"
export * from "./LogInMenu.vue?vue&type=script&lang=js"

import "./LogInMenu.vue?vue&type=style&index=0&id=0fba3e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fba3e46"]])

export default __exports__